// extracted by mini-css-extract-plugin
module.exports = {"lia-grid-wrap":"GridList_lia-grid-wrap__pG_7r","lia-grid":"GridList_lia-grid__q7Qmb","lia-flex":"GridList_lia-flex__kZwEh"};